var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 234,
    height: 212,
    viewBox: "0 0 234 212",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-artwork"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 234,
    height: 212
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "artwork",
    clipPath: "url(#clip-artwork)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_well_done_i2wr",
    transform: "translate(2.058 1.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31623",
    "data-name": "Path 31623",
    d: "M375.259,278.705c-3.953-11.816-16.16-18.383-24.19-15.7s-13.828,15.277-9.876,27.093c3.659,10.937,14.746,17.251,22.373,16.124a.865.865,0,0,0-.107.31l-.233,1.945a.876.876,0,0,0,1.166.929L368.32,308a.876.876,0,0,0,.31-1.458l-1.416-1.354a.869.869,0,0,0-.166-.119C373.851,301.4,378.925,289.666,375.259,278.705Z",
    transform: "translate(-318.301 -226.169)",
    fill: "#e9edf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31624",
    "data-name": "Path 31624",
    d: "M397.967,281.49a14.414,14.414,0,0,1,6.522,18.75c-.34.774.91,1.181,1.248.412A15.761,15.761,0,0,0,398.7,280.4C397.954,280,397.22,281.094,397.967,281.49Z",
    transform: "translate(-355.319 -237.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31625",
    "data-name": "Path 31625",
    d: "M821.259,230.705c-3.953-11.816-16.16-18.383-24.19-15.7s-13.828,15.277-9.876,27.093c3.659,10.937,14.746,17.251,22.373,16.124a.865.865,0,0,0-.107.31l-.233,1.945a.876.876,0,0,0,1.166.929L814.32,260a.876.876,0,0,0,.31-1.458l-1.416-1.354a.866.866,0,0,0-.166-.119C819.851,253.4,824.925,241.666,821.259,230.705Z",
    transform: "translate(-604.265 -195.393)",
    fill: "#e9edf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31626",
    "data-name": "Path 31626",
    d: "M843.966,233.49a14.414,14.414,0,0,1,6.523,18.75c-.34.774.91,1.181,1.248.412A15.761,15.761,0,0,0,844.7,232.4C843.954,232,843.22,233.094,843.966,233.49Z",
    transform: "translate(-641.282 -206.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31627",
    "data-name": "Path 31627",
    d: "M562.259,177.705c-3.953-11.816-16.16-18.383-24.19-15.7s-13.828,15.277-9.875,27.093c3.659,10.937,14.746,17.251,22.373,16.124a.865.865,0,0,0-.107.31l-.233,1.945a.876.876,0,0,0,1.166.929L555.32,207a.876.876,0,0,0,.31-1.458l-1.416-1.354a.866.866,0,0,0-.166-.119C560.851,200.4,565.925,188.666,562.259,177.705Z",
    transform: "translate(-438.201 -161.411)",
    fill: "#e9edf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31628",
    "data-name": "Path 31628",
    d: "M584.967,180.49a14.414,14.414,0,0,1,6.523,18.75c-.34.774.91,1.181,1.248.412A15.761,15.761,0,0,0,585.7,179.4C584.954,179,584.22,180.094,584.967,180.49Z",
    transform: "translate(-475.218 -172.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1213",
    "data-name": "Ellipse 1213",
    cx: 0.942,
    cy: 0.942,
    r: 0.942,
    transform: "translate(103.291 71.268)",
    fill: "#e9edf5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1214",
    "data-name": "Ellipse 1214",
    cx: 1.86,
    cy: 1.86,
    r: 1.86,
    transform: "translate(100.365 107.207)",
    fill: "#e9edf5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1215",
    "data-name": "Ellipse 1215",
    cx: 1.075,
    cy: 1.075,
    r: 1.075,
    transform: "translate(70.006 101.615)",
    fill: "#e9edf5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1216",
    "data-name": "Ellipse 1216",
    cx: 1.164,
    cy: 1.164,
    r: 1.164,
    transform: "translate(86.248 83.835)",
    fill: "#e9edf5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1217",
    "data-name": "Ellipse 1217",
    cx: 0.942,
    cy: 0.942,
    r: 0.942,
    transform: "translate(143.755 152.438)",
    fill: "#e9edf5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1218",
    "data-name": "Ellipse 1218",
    cx: 1.86,
    cy: 1.86,
    r: 1.86,
    transform: "translate(111.996 131.236)",
    fill: "#e9edf5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1219",
    "data-name": "Ellipse 1219",
    cx: 1.075,
    cy: 1.075,
    r: 1.075,
    transform: "translate(133.965 108.317)",
    fill: "#e9edf5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1220",
    "data-name": "Ellipse 1220",
    cx: 1.164,
    cy: 1.164,
    r: 1.164,
    transform: "translate(140.946 131.244)",
    fill: "#e9edf5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1221",
    "data-name": "Ellipse 1221",
    cx: 2.426,
    cy: 7.727,
    rx: 2.426,
    ry: 7.727,
    transform: "translate(193.034 183.24) rotate(-39.938)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1222",
    "data-name": "Ellipse 1222",
    cx: 15.454,
    cy: 15.454,
    r: 15.454,
    transform: "translate(167.963 169.469)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29804",
    "data-name": "Rectangle 29804",
    width: 4.695,
    height: 8.412,
    transform: "translate(185.263 197.05)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29805",
    "data-name": "Rectangle 29805",
    width: 4.695,
    height: 8.412,
    transform: "translate(175.873 197.05)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1223",
    "data-name": "Ellipse 1223",
    cx: 3.912,
    cy: 1.467,
    rx: 3.912,
    ry: 1.467,
    transform: "translate(182.133 204.093)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1224",
    "data-name": "Ellipse 1224",
    cx: 3.912,
    cy: 1.467,
    rx: 3.912,
    ry: 1.467,
    transform: "translate(172.743 203.897)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31629",
    "data-name": "Path 31629",
    d: "M776.914,608.907c1.38-5.557,7.471-8.827,13.6-7.3s9.988,7.263,8.608,12.82-5.958,5.575-12.092,4.052S775.534,614.464,776.914,608.907Z",
    transform: "translate(-598.35 -443.411)",
    fill: "#e9edf5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1225",
    "data-name": "Ellipse 1225",
    cx: 2.426,
    cy: 7.727,
    rx: 2.426,
    ry: 7.727,
    transform: "translate(157.99 176.632) rotate(-64.626)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1226",
    "data-name": "Ellipse 1226",
    cx: 5.152,
    cy: 5.152,
    r: 5.152,
    transform: "translate(175.954 176.509)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1227",
    "data-name": "Ellipse 1227",
    cx: 1.717,
    cy: 1.717,
    r: 1.717,
    transform: "translate(177.271 178.097)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31630",
    "data-name": "Path 31630",
    d: "M781.23,694.391a3.435,3.435,0,0,1-6.759,1.23h0v-.007c-.338-1.867,1.105-2.527,2.972-2.865S780.892,692.525,781.23,694.391Z",
    transform: "translate(-596.891 -501.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1228",
    "data-name": "Ellipse 1228",
    cx: 7.727,
    cy: 2.426,
    rx: 7.727,
    ry: 2.426,
    transform: "matrix(0.357, -0.934, 0.934, 0.357, 49.074, 179.605)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1229",
    "data-name": "Ellipse 1229",
    cx: 15.454,
    cy: 15.454,
    r: 15.454,
    transform: "translate(24.361 169.469)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29806",
    "data-name": "Rectangle 29806",
    width: 4.695,
    height: 8.412,
    transform: "translate(32.773 197.05)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29807",
    "data-name": "Rectangle 29807",
    width: 4.695,
    height: 8.412,
    transform: "translate(42.162 197.05)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1230",
    "data-name": "Ellipse 1230",
    cx: 3.912,
    cy: 1.467,
    rx: 3.912,
    ry: 1.467,
    transform: "translate(32.773 204.093)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1231",
    "data-name": "Ellipse 1231",
    cx: 3.912,
    cy: 1.467,
    rx: 3.912,
    ry: 1.467,
    transform: "translate(42.162 203.897)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1232",
    "data-name": "Ellipse 1232",
    cx: 5.282,
    cy: 5.282,
    r: 5.282,
    transform: "translate(34.925 175.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1233",
    "data-name": "Ellipse 1233",
    cx: 1.761,
    cy: 1.761,
    r: 1.761,
    transform: "translate(38.446 179.249)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31631",
    "data-name": "Path 31631",
    d: "M348.445,613.63c-1.248-5.588,2.741-11.235,8.909-12.612s12.18,2.036,13.428,7.625-2.84,7.649-9.008,9.027S349.693,619.219,348.445,613.63Z",
    transform: "translate(-323.621 -443.079)",
    fill: "#e9edf5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1234",
    "data-name": "Ellipse 1234",
    cx: 2.426,
    cy: 7.727,
    rx: 2.426,
    ry: 7.727,
    transform: "translate(14.389 176.632) rotate(-64.626)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31632",
    "data-name": "Path 31632",
    d: "M369.476,688.95c0,1.512,3.894,4.5,8.216,4.5s8.373-4.258,8.373-5.771-4.052.293-8.373.293S369.476,687.437,369.476,688.95Z",
    transform: "translate(-337.252 -498.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1235",
    "data-name": "Ellipse 1235",
    cx: 15.454,
    cy: 15.454,
    r: 15.454,
    transform: "translate(98.179 154.757)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29808",
    "data-name": "Rectangle 29808",
    width: 4.695,
    height: 8.412,
    transform: "translate(106.59 182.339)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29809",
    "data-name": "Rectangle 29809",
    width: 4.695,
    height: 8.412,
    transform: "translate(115.98 182.339)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1236",
    "data-name": "Ellipse 1236",
    cx: 3.912,
    cy: 1.467,
    rx: 3.912,
    ry: 1.467,
    transform: "translate(106.59 189.381)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1237",
    "data-name": "Ellipse 1237",
    cx: 3.912,
    cy: 1.467,
    rx: 3.912,
    ry: 1.467,
    transform: "translate(115.98 189.185)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31633",
    "data-name": "Path 31633",
    d: "M554.165,572.63c-1.248-5.588,2.741-11.235,8.909-12.612s12.18,2.036,13.428,7.625-2.84,7.649-9.008,9.027S555.413,578.219,554.165,572.63Z",
    transform: "translate(-455.523 -416.791)",
    fill: "#4d7cfa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1238",
    "data-name": "Ellipse 1238",
    cx: 8.573,
    cy: 2.691,
    rx: 8.573,
    ry: 2.691,
    transform: "translate(120.417 165.716) rotate(-45.022)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1239",
    "data-name": "Ellipse 1239",
    cx: 2.691,
    cy: 8.573,
    rx: 2.691,
    ry: 8.573,
    transform: "translate(87.152 158.47) rotate(-44.978)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31634",
    "data-name": "Path 31634",
    d: "M775.6,312.5c-.513-15.846-11.366-28.353-24.24-27.936-28.653.849-29.353,53.394-1.689,57.168l-.586,4.656,8.544-.277-.886-4.608C767.872,339.038,776.066,326.861,775.6,312.5Z",
    transform: "translate(-568.017 -240.363)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31635",
    "data-name": "Path 31635",
    d: "M743.135,354.233l-3.228.1a52.563,52.563,0,0,1-.592-18.291l3.228-.1A40.449,40.449,0,0,0,743.135,354.233Z",
    transform: "translate(-574.041 -273.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29810",
    "data-name": "Rectangle 29810",
    width: 9.688,
    height: 2.153,
    transform: "matrix(0.999, -0.032, 0.032, 0.999, 180.349, 101.376)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31636",
    "data-name": "Path 31636",
    d: "M449.466,365.185l-.975-.456,23.974-81.3.975.457Z",
    transform: "translate(-287.561 -181.727)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31637",
    "data-name": "Path 31637",
    d: "M831.761,333.975c5.855-14.733.9-30.533-11.074-35.29-26.611-10.659-48.226,37.239-24.369,51.742l-2.4,4.035,7.944,3.157,1.027-4.579C814.08,355.227,826.453,347.333,831.761,333.975Z",
    transform: "translate(-604.335 -248.444)",
    fill: "#4d7cfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31638",
    "data-name": "Path 31638",
    d: "M799.992,346.887l-3-1.193a52.566,52.566,0,0,1,6.758-17.007l3,1.193A40.445,40.445,0,0,0,799.992,346.887Z",
    transform: "translate(-611.363 -268.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29811",
    "data-name": "Rectangle 29811",
    width: 2.153,
    height: 9.688,
    transform: "translate(189.985 103.474) rotate(-68.328)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31639",
    "data-name": "Path 31639",
    d: "M449.008,367.872l-.935-.532,33.471-76.383.935.532Z",
    transform: "translate(-287.293 -186.554)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31640",
    "data-name": "Path 31640",
    d: "M325.168,332.04c-6.334-14.534-21.042-22.143-32.851-17-26.31,11.381-7.536,60.463,19.564,53.743l1.177,4.543,7.836-3.415-2.526-3.954C327.8,359.56,330.911,345.216,325.168,332.04Z",
    transform: "translate(-279.671 -258.884)",
    fill: "#4d7cfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31641",
    "data-name": "Path 31641",
    d: "M297.494,397.71l-2.96,1.29a52.565,52.565,0,0,1-7.312-16.776l2.96-1.29A40.447,40.447,0,0,0,297.494,397.71Z",
    transform: "translate(-284.512 -302.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29812",
    "data-name": "Rectangle 29812",
    width: 9.688,
    height: 2.153,
    transform: "matrix(0.917, -0.4, 0.4, 0.917, 30.999, 110.396)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31642",
    "data-name": "Path 31642",
    d: "M405.109,539.622h0a.538.538,0,0,1-.652-.393l-23.4-74.139,1.045-.259,23.4,74.139A.538.538,0,0,1,405.109,539.622Z",
    transform: "translate(-344.678 -355.955)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31643",
    "data-name": "Path 31643",
    d: "M364.2,738.549H307.869c-.2,0-.359-.439-.359-.98s.161-.98.359-.98H364.2c.2,0,.359.439.359.98S364.4,738.549,364.2,738.549Z",
    transform: "translate(-297.521 -530.2)",
    fill: "#e9edf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31644",
    "data-name": "Path 31644",
    d: "M763.2,738.549H706.869c-.2,0-.359-.439-.359-.98s.161-.98.359-.98H763.2c.2,0,.359.439.359.98S763.4,738.549,763.2,738.549Z",
    transform: "translate(-553.349 -530.2)",
    fill: "#e9edf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31645",
    "data-name": "Path 31645",
    d: "M576.2,697.549H519.869c-.2,0-.359-.439-.359-.98s.161-.98.359-.98H576.2c.2,0,.359.439.359.98S576.4,697.549,576.2,697.549Z",
    transform: "translate(-433.45 -503.912)",
    fill: "#e9edf5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1240",
    "data-name": "Ellipse 1240",
    cx: 5.282,
    cy: 5.282,
    r: 5.282,
    transform: "translate(107.701 162.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1241",
    "data-name": "Ellipse 1241",
    cx: 1.761,
    cy: 1.761,
    r: 1.761,
    transform: "translate(111.222 166.26)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31646",
    "data-name": "Path 31646",
    d: "M594.055,653.683a3.435,3.435,0,0,1-6.759,1.23h0v-.007c-.338-1.867,1.105-2.527,2.972-2.865S593.717,651.816,594.055,653.683Z",
    transform: "translate(-476.88 -475.894)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtwork);
export default __webpack_public_path__ + "static/media/artwork.abad22ca88ffe38a85f8b139b23cc76e.svg";
export { ForwardRef as ReactComponent };